
import { Form } from "../models/formModel";
import { Prototype } from "../models/prototypeModel";
import { EDIT_PROTOTYPE, ProtoTypeActionTypes, SET_PROTOTYPE } from "../types/actions";

const startForm = {} as Form;
const lastForm = {} as Form;
startForm.id = "Start";
startForm.name = "Start";
lastForm.id = "End";
lastForm.name = "End";
const protoTypeReducerDefaultState: Prototype = { id: '' , projectId : '' , formList: [startForm, lastForm] , name: ''};

const protoTypeReducer = (state : Prototype = protoTypeReducerDefaultState, action : ProtoTypeActionTypes) : Prototype => {
    switch (action.type) {
        case SET_PROTOTYPE:
            return action.protoType;
        case EDIT_PROTOTYPE:
            return {...state,...action.protoType}
        default:
            return state;
    }
}

export default protoTypeReducer
